import { Component } from 'react'
import Icon from '../../Nodes/Icon'

class Collapse extends Component {
    state = { open: false }
  
    render() {
        const { open } = this.state
        const { title, className, children, background, color } = this.props
        
        const collapseClassName = ' collapse' + (open ? '' : ' collapse--hidden')
        
        const style = {}
        if (background)
            style["background"] = background
        if (color)
            style["color"] = color

        return (
            <div className={(className || '') + collapseClassName}>
                <div 
                    className="collapse__title"
                    style={style}
                    onClick={() => this.setState({ open: !open })}>
                    <span dangerouslySetInnerHTML={{ __html: title }} />
                    <span><Icon>{open ? 'expand_less' : 'expand_more'}</Icon></span>
                </div>
                <div className="collapse__body">{children}</div>
            </div>
        )    
    }

    componentDidMount() {
        if (this.props.open)
            this.setState({ open: true })
    }
}

export default Collapse